(() => {
  "use strict";

  const MINIMUM_ORDER_CENTS = 3500;
  const ROOT = window.Shopify?.routes?.root || "/";
  const CART_URL = `${ROOT}cart.js`;

  const CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '#checkout',
    '#CartDrawer-Checkout',
    '.cart__checkout-button',
    'a[href="/checkout"]',
    'a[href*="/checkout"]'
  ].join(",");

  let lastCartSignature = "";
  let checkRunning = false;

  async function loadCart() {
    const response = await fetch(CART_URL, {
      credentials: "same-origin",
      headers: {
        Accept: "application/json"
      },
      cache: "no-store"
    });

    if (!response.ok) {
      throw new Error(`Warenkorb konnte nicht geladen werden: ${response.status}`);
    }

    return response.json();
  }

  function isAutomaticDeposit(item) {
    return String(
      item.properties?._koller_auto_pfand || ""
    ) === "1";
  }

  function calculateGoodsValue(cart) {
    return cart.items.reduce((sum, item) => {
      if (isAutomaticDeposit(item)) {
        return sum;
      }

      return sum + Number(
        item.final_line_price ?? item.line_price ?? 0
      );
    }, 0);
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR"
    }).format(cents / 100);
  }

  function findCheckoutButtons() {
    return Array.from(
      document.querySelectorAll(CHECKOUT_SELECTOR)
    );
  }

  function getNoticeContainer(button) {
    return (
      button.closest(".cart__ctas") ||
      button.closest(".drawer__footer") ||
      button.parentElement
    );
  }

  function getOrCreateNotice(button) {
    const container = getNoticeContainer(button);

    if (!container) {
      return null;
    }

    let notice = container.querySelector(
      ".koller-minimum-order-notice"
    );

    if (!notice) {
      notice = document.createElement("div");
      notice.className = "koller-minimum-order-notice";
      notice.setAttribute("role", "status");
      notice.setAttribute("aria-live", "polite");
      container.insertBefore(notice, button);
    }

    return notice;
  }

  function setButtonState(button, enabled) {
    button.classList.toggle(
      "koller-minimum-order-disabled",
      !enabled
    );

    button.setAttribute(
      "aria-disabled",
      enabled ? "false" : "true"
    );

    if (
      button instanceof HTMLButtonElement ||
      button instanceof HTMLInputElement
    ) {
      button.disabled = !enabled;
    }

    if (button instanceof HTMLAnchorElement) {
      if (enabled) {
        button.removeAttribute("tabindex");
      } else {
        button.setAttribute("tabindex", "-1");
      }
    }
  }

  function renderState(cart) {
    const goodsValue = calculateGoodsValue(cart);
    const minimumReached =
      goodsValue >= MINIMUM_ORDER_CENTS;

    const missingAmount = Math.max(
      MINIMUM_ORDER_CENTS - goodsValue,
      0
    );

    findCheckoutButtons().forEach((button) => {
      setButtonState(button, minimumReached);

      const notice = getOrCreateNotice(button);

      if (!notice) {
        return;
      }

      notice.classList.toggle(
        "koller-minimum-order-notice--success",
        minimumReached
      );

      if (minimumReached) {
        notice.innerHTML = `
          <strong>🎉 Mindestbestellwert erreicht!</strong>
          <span>
            Vielen Dank für Ihre Bestellung.
Sie können jetzt bequem zur Kasse gehen.
          </span>
        `;
      } else {
        notice.innerHTML = `
          <strong>
            Mindestbestellwert: 35,00 € ohne Pfand
          </strong>
          <span>
          Es fehlen nur noch <strong>${formatMoney(missingAmount)}</strong>
    bis zu Ihrer Lieferung.
          </span>
        `;
      }
    });
  }

  async function checkMinimumOrder() {
    if (checkRunning) {
      return;
    }

    checkRunning = true;

    try {
      const cart = await loadCart();

      const signature = JSON.stringify(
        cart.items.map((item) => [
          item.key,
          item.quantity,
          item.final_line_price,
          item.properties?._koller_auto_pfand || ""
        ])
      );

      if (
        signature !== lastCartSignature ||
        findCheckoutButtons().some(
          (button) =>
            !getNoticeContainer(button)?.querySelector(
              ".koller-minimum-order-notice"
            )
        )
      ) {
        lastCartSignature = signature;
        renderState(cart);
      }
    } catch (error) {
      console.error(
        "Koller-Mindestbestellwert:",
        error
      );
    } finally {
      checkRunning = false;
    }
  }

  document.addEventListener(
    "click",
    async (event) => {
      const checkoutButton =
        event.target.closest(CHECKOUT_SELECTOR);

      if (!checkoutButton) {
        return;
      }

      const cart = await loadCart();
      const goodsValue = calculateGoodsValue(cart);

      if (goodsValue < MINIMUM_ORDER_CENTS) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        renderState(cart);

        document
          .querySelector(".koller-minimum-order-notice")
          ?.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
      }
    },
    true
  );

  function initialize() {
    checkMinimumOrder();

    /*
     * Keine Änderung an window.fetch.
     * Die Pfandlogik bleibt vollständig unabhängig.
     */
    window.setInterval(checkMinimumOrder, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize
    );
  } else {
    initialize();
  }
})();